export default "__VITE_ASSET__e1820d04__"